import React, { createContext, useContext, useReducer } from 'react';

// Data Layer setup:
export const StateContext = createContext();

export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {/* data layer wrapper */}
    {children}
  </StateContext.Provider>
);

export const useStateValue = () => useContext(StateContext); // Custom hook to pull info from data layer
